import { render, staticRenderFns } from "./SessionDataDialog.vue?vue&type=template&id=0956ec3c&"
import script from "./SessionDataDialog.vue?vue&type=script&lang=js&"
export * from "./SessionDataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports